import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface TableState {
  page: number
  rowsPerPage: number
  search: string
  totalCount: number
}

interface TablesState {
  [key: string]: TableState
}

const defaultState: TableState = {
  page: 0,
  rowsPerPage: 10,
  search: '',
  totalCount: 0,
}

const tableSlice = createSlice({
  name: 'tables',
  initialState: {} as TablesState,
  reducers: {
    setPage(state, action: PayloadAction<{ key: string; page: number }>) {
      const { key, page } = action.payload
      if (!state[key]) state[key] = { ...defaultState }
      state[key].page = page
    },
    setRowsPerPage(state, action: PayloadAction<{ key: string; rowsPerPage: number }>) {
      const { key, rowsPerPage } = action.payload
      if (!state[key]) state[key] = { ...defaultState }
      state[key].rowsPerPage = rowsPerPage
      state[key].page = 0
    },
    setSearch(state, action: PayloadAction<{ key: string; search: string }>) {
      const { key, search } = action.payload
      if (!state[key]) state[key] = { ...defaultState }
      state[key].search = search
      state[key].page = 0
    },
    setTotalCount(state, action: PayloadAction<{ key: string; totalCount: number }>) {
      const { key, totalCount } = action.payload
      if (!state[key]) state[key] = { ...defaultState }
      state[key].totalCount = totalCount
    },
  },
})

export const { setPage, setRowsPerPage, setSearch, setTotalCount } = tableSlice.actions
export default tableSlice.reducer
